import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "w-full lg:rounded-2xl sm:rounded-xl rounded-2xl sm:flex mt-4 sm:mt-0" }
const _hoisted_2 = {
  type: "button",
  class: "inline-flex items-center content-start justify-between w-full h-10 lg:rounded-2xl rounded-x px-4 bg-primary-000 text-sm leading-5 font-medium text-secondary-500 hover:text-secondary-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-secondary-600 transition ease-in-out duration-150 btn-focus dark:bg-primaryDark-black dark:border-backgrounddark-500",
  "aria-haspopup": "true",
  "aria-expanded": "true"
}
const _hoisted_3 = { class: "w-56" }
const _hoisted_4 = { class: "pt-2 z-30" }
const _hoisted_5 = {
  key: 0,
  class: "w-56 flex py-4 px-2 items-center"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Tout ")
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "border-t border-gray-100" }, null, -1)
const _hoisted_9 = { class: "w-56" }
const _hoisted_10 = {
  key: 0,
  class: "py-4 px-2 flex"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_12 = { class: "me-1 flex-grow" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("   ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ps_icon = _resolveComponent("ps-icon")!
  const _component_ps_label = _resolveComponent("ps-label")!
  const _component_ps_input_with_left_icon = _resolveComponent("ps-input-with-left-icon")!
  const _component_ps_label_caption = _resolveComponent("ps-label-caption")!
  const _component_ps_dropdown = _resolveComponent("ps-dropdown")!
  const _component_ps_loading_dialog = _resolveComponent("ps-loading-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ps_dropdown, {
        id: $setup.locationId ?? 'locaitonid',
        align: "left",
        class: "sm:w-3/12 my-2 sm:my-0 w-full h-full lg:rounded-2xl rounded-x",
        onOnClick: $setup.loadLocationList,
        onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => ($setup.filterKeywordUpate($setup.locationKeyword)), ["enter"]))
      }, {
        select: _withCtx(() => [
          _createVNode(_component_ps_label, { class: "lg:rounded-2xl rounded-x h-full" }, {
            default: _withCtx(() => [
              _createElementVNode("button", _hoisted_2, [
                _createVNode(_component_ps_icon, {
                  textColor: "text-secondary-400 dark:text-secondaryDark-grey",
                  name: "location"
                }),
                _createVNode(_component_ps_label, { class: "text-start text-xs sm:text-xxs lg:text-xs" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.locationName), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ps_icon, {
                  textColor: "text-secondary-400 dark:text-secondaryDark-grey",
                  name: "downArrow"
                })
              ])
            ]),
            _: 1
          })
        ]),
        filter: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ps_input_with_left_icon, {
              class: "rounded-xl flex-1",
              value: $setup.locationKeyword,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.locationKeyword) = $event))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_ps_icon, {
                  textColor: "text-secondary-400 dark:text-secondaryDark-grey",
                  name: "search",
                  class: "cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.filterKeywordUpate($setup.locationKeyword)))
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ]),
        list: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            ($setup.itemlocationProvider.loading.value == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_ps_label_caption, { class: "ms-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("search_for_large_screem__loading")), 1)
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "w-56 flex py-4 px-2 hover:bg-primary-000 dark:hover:bg-primaryDark-black cursor-pointer items-center",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.locationFilterClicked('', 'All', '', '')))
                }, [
                  _createVNode(_component_ps_label, {
                    class: _normalizeClass(["ms-2", $setup.locationId == '' ? ' font-bold text-primary-700' : ''])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["class"])
                ])),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.itemlocationProvider.itemLocationList.data, (selectData) => {
              return (_openBlock(), _createElementBlock("div", {
                key: selectData.id,
                class: "w-56 flex py-4 px-2 hover:bg-primary-000 dark:hover:bg-primaryDark-black cursor-pointer items-center",
                onClick: ($event: any) => ($setup.locationFilterClicked(selectData.id, selectData.name, selectData.lat, selectData.lng))
              }, [
                _createVNode(_component_ps_label, {
                  class: _normalizeClass(["ms-2", selectData.id == $setup.locationId ? ' font-bold text-primary-700' : ''])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(selectData.name), 1)
                  ]),
                  _: 2
                }, 1032, ["class"])
              ], 8, _hoisted_7))
            }), 128)),
            _hoisted_8
          ])
        ]),
        loadmore: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            ($setup.itemlocationProvider.itemLocationList.data != null
                        && $setup.itemlocationProvider.loading.value == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_ps_label_caption, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("search_for_large_screem__loading")), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_ps_label, {
              class: "flex py-4 px-2 underline font-bold cursor-pointer ms-2",
              onClick: $setup.loadLocationList
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("search_for_large_screem__load_more")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["id", "onOnClick"]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_ps_input_with_left_icon, {
          theme: "ring-primary-200 dark:ring-primaryDark-grey focus:outline-none focus:ring focus:border-primary-200 lg:rounded-2xl rounded-x bg-primary-000 dark:bg-primaryDark-black text-secondary-500 dark:text-secondaryDark-white",
          height: "h-10",
          onKeyup: _withKeys($setup.searchClicked, ["enter"]),
          value: $setup.searchKeyword,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (($setup.searchKeyword) = $event)),
          placeholder: _ctx.$t('search_for_large_screem__search')
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_ps_icon, {
              textColor: "text-secondary-400 dark:text-secondaryDark-grey",
              name: "search",
              class: "cursor-pointer"
            })
          ]),
          _: 1
        }, 8, ["onKeyup", "value", "placeholder"])
      ]),
      _hoisted_13
    ]),
    _createVNode(_component_ps_loading_dialog, {
      ref: "ps_loading_dialog",
      isClickOut: false
    }, null, 512)
  ], 64))
}